export default __webpack_public_path__ + "fcbb4e682f28b1cde2c3e59953848009.png";